module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/issue-2/ar/img/silver-lining-mobile.3fb24f13.jpg";